export const PROFILE_SELECTOR_IDP_APPS = 'PROFILE_SELECTOR';

export const LOGO_URL =
  'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png';

export const BUSINESS_DESCRIPTION =
  'Book flights, check-in and manage your business account.';

export const ADMIN_DESCRIPTION =
  'Manage your corporate travel program through groups.';

export const SKY_BONUS_DESCRIPTION = 'Manage your corporate loyalty account.';

export const PERSONAL = 'personal';

export const BUSINESS = 'Business';

export const DOMAIN_PROD_URL = 'https://www.delta.com';

export const PROGRAM_TYPE = {
  SKYB: 'SKYB',
  SKB: 'SKB'
};

export const BUSINESS_OPTIONS = {
  partnerId: 'partnerId',
  restrictOnePax: 'restrictOnePax',
  disableMiles: 'disableMiles',
  displayInlineText: 'displayInlineText'
};

export const CRAM_BBIZ_NAME: { [key: string]: string } = {
  CRAM: 'CLUB PREMIER CORPORATE',
  BBIZ: 'BLUEBIZ'
};

export const DEFAULT_COOKIE_DOMAIN_VALUE = '.delta.com';

export const PERM_TYPE = {
  A: 'A',
  B: 'B',
  S: 'S',
  NA: 'NA',
  P: 'P'
};

export const CorpAgreementData: { [key: string]: string } = {
  edp: 'EDP',
  sme: 'SME',
  edpCna: 'CNA',
  concur: 'TRIP',
  concurold: 'CONCUR',
  nutravel: 'NTVL',
  noprogram: 'NPGM',
  corporateRewards: 'CRWD'
};

export const BUSINESS_TITLE = {
  BUSINESS_TRAVEL: 'Business Travel',
  MANAGE_TRAVEL_PROGRAM: 'Manage Travel Program',
  SKYMILES_FOR_BUSINESS: 'SkyMiles for Business'
};

export const HOME_PAGE_URL = '/';
export const AEM_CONTENT = '/content';
export const AEM_STATICURL = 'staticurl';
export const AEM_SMT = 'smt';
export const AEM_HTML = 'html';
export const AEM_AIR_SHOPPING = 'air-shopping';
export const WIFI_PORTAL = 'wifi';
export const DOT_DELTA_COM = '.delta.com';
export const SKYMILES_LOGIN = 'skymiles/login';
export const NuTRAVEL_ADMIN_ACTION_PROD_URL =
  'https://businessmanagement.delta.com/oidc.html';
export const NuTRAVEL_ADMIN_ACTION_DEV_URL =
  'https://deltaUAT-web01.nutravel.com/oidc.html';
export const SKYBONUS_DEV_URL =
  'https://deltaglobalsales--skybonussi.sandbox.my.site.com/skybonus/services/auth/sso/SkyBonus_Auth_Provider';
export const SKYBONUS_PROD_URL = 'https://SkymilesForBusiness.delta.com';
export const LOGIN_DL_VS_ROUTES_REGEX =
  /\b(skymiles\/addEmail|skymiles\/addSQA|skymiles\/addAddress|skymiles\/login|skymiles\/resetPassword|skymiles\/forgotLogin|skymiles\/profilePickerPage|skymiles\/loginHelp|skymiles\/unlockYourAccount|skymiles\/index.html|flyingclub\/login|flyingclub\/resetPassword|flyingclub\/forgotLogin|flyingclub\/unlockYourAccount|flyingclub\/index.html)\b/;

export const IS_CRAM_BBIZ_REGEX = /\b(CRAM|BBIZ)\b/;

export const APP_MEETING_CODE = 'NPGM,CRWD,SME';
export const APP_BUSINESS_OA_SME_ACCOUNTS = 'BBIZ,CRG3,CRAM,SKYB';
export const APP_CORPORATE_AGREEMENT_TYPE_CODE =
  'edp:EDP,edpCna:CNA,concur:TRIP,concurold:CONCUR,nutravel:NTVL,sme:SME,corporateRewards:CRWD,noprogram:NPGM';

export const BAU_URLS = [
  'delta.com/mytrips/',
  'delta.com/vacations/',
  'delta.com/contactus/',
  'delta.com/buygftxfer/',
  'delta.com/skyclub/',
  'delta.com/cartalacarte',
  'delta.com/seat'
];

export const CORPORATE_AGREEMENT_TYPE_CODE = {
  NTVL: 'NTVL',
  SME: 'SME'
};

export const PROGRAM_TYPE_TERMS_OF_USE = {
  SKYB: 'SKYB',
  SKB: 'SKB'
};
